/**
 * dsar.ts — Zod schemas for GDPR DSAR (Data Subject Access Request) endpoints.
 *
 * Extracted from worker/src/routes/dsar.ts (2026-05-12) when the Fastify HTTP
 * layer was removed from the worker (now a headless reactor).
 *
 * These schemas will be reused when DSAR endpoints are re-implemented as a
 * web-app API route (Next.js API routes or a dedicated Fastify service
 * alongside the client app).
 */

import { z } from 'zod';

export const DsarRequestBody = z.object({
  email: z.string().email(),
  type: z.enum(['export', 'erasure', 'access', 'portability', 'rectification']),
  lang_code: z.enum(['pl', 'en', 'de', 'cs']),
  country_code: z.enum(['PL', 'DE', 'CZ', 'UA']),
});
export type DsarRequestBody = z.infer<typeof DsarRequestBody>;

export const DsarFulfillBody = z.object({
  token: z.string().uuid(),
  action: z.enum(['export', 'erase']).optional(),
});
export type DsarFulfillBody = z.infer<typeof DsarFulfillBody>;

export const DsarStatusParams = z.object({
  token: z.string().uuid(),
});
export type DsarStatusParams = z.infer<typeof DsarStatusParams>;
